import api from './client.js'

export const filesAPI = {
  getFiles: (params) => api.get('/files', { params }),
  getCategories: () => api.get('/files/categories'),
  uploadFile: (formData) => api.post('/files', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteFile: (fileId) => api.delete(`/files/${fileId}`),
  downloadFile: (fileId) => api.get(`/files/${fileId}/download`, { responseType: 'blob' }),
}

export const gameFoldersAPI = {
  getFolders: () => api.get('/game-folders'),
  getFiles: (folderId) => api.get(`/game-folders/${folderId}/files`),
  createFolder: (data) => api.post('/game-folders', data),
  updateFolder: (folderId, data) => api.put(`/game-folders/${folderId}`, data),
  deleteFolder: (folderId) => api.delete(`/game-folders/${folderId}`),
  uploadFile: (folderId, formData) => api.post(`/game-folders/${folderId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteFile: (folderId, fileId) => api.delete(`/game-folders/${folderId}/files/${fileId}`),
  getDownloadUrl: (folderId) => `/api/game-folders/${folderId}/download`,
}

export const eventsAPI = {
  getEvents: (params) => api.get('/events', { params }),
  getEvent: (eventId) => api.get(`/events/${eventId}`),
  createEvent: (eventData) => api.post('/events', eventData),
  updateEvent: (eventId, eventData) => api.put(`/events/${eventId}`, eventData),
  deleteEvent: (eventId) => api.delete(`/events/${eventId}`),
  joinEvent: (eventId) => api.post(`/events/${eventId}/join`),
  leaveEvent: (eventId) => api.post(`/events/${eventId}/leave`),
  getAllPages: (params) => api.get('/events', { params }),
  getPage: (pageId) => api.get(`/events/${pageId}`),
  createPage: (pageData) => api.post('/events', pageData),
  updatePage: (pageId, pageData) => api.put(`/events/${pageId}`, pageData),
  deletePage: (pageId) => api.delete(`/events/${pageId}`),
}

export const pollsAPI = {
  getPolls: (params) => api.get('/polls', { params }),
  getPoll: (pollId) => api.get(`/polls/${pollId}`),
  createPoll: (pollData) => api.post('/polls', pollData),
  votePoll: (pollId, optionId) => api.post(`/polls/${pollId}/vote`, { optionId }),
  closePoll: (pollId) => api.patch(`/polls/${pollId}/close`),
  deletePoll: (pollId) => api.delete(`/polls/${pollId}`),
  togglePinPoll: (pollId) => api.patch(`/polls/${pollId}/pin`),
}

export const screenshotsAPI = {
  getScreenshots: (params) => api.get('/screenshots', { params }),
  getScreenshot: (screenshotId) => api.get(`/screenshots/${screenshotId}`),
  uploadScreenshot: (formData) => api.post('/screenshots', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  updateScreenshot: (screenshotId, data) => api.patch(`/screenshots/${screenshotId}`, data),
  deleteScreenshot: (screenshotId) => api.delete(`/screenshots/${screenshotId}`),
  tagUser: (screenshotId, userId) => api.post(`/screenshots/${screenshotId}/tags`, { user_id: userId }),
  untagUser: (screenshotId, userId) => api.delete(`/screenshots/${screenshotId}/tags/${userId}`),
  addComment: (screenshotId, comment) => api.post(`/screenshots/${screenshotId}/comments`, { comment }),
  deleteComment: (commentId) => api.delete(`/screenshots/comments/${commentId}`),
  likeScreenshot: (screenshotId) => api.post(`/screenshots/${screenshotId}/like`),
  unlikeScreenshot: (screenshotId) => api.delete(`/screenshots/${screenshotId}/like`),
  getScreenshotUrl: (filename) => `/api/screenshots/file/${filename}`,
}

export const albumsAPI = {
  getAlbums: () => api.get('/albums'),
  getAlbum: (albumId) => api.get(`/albums/${albumId}`),
  createAlbum: (albumData) => api.post('/albums', albumData),
  updateAlbum: (albumId, albumData) => api.put(`/albums/${albumId}`, albumData),
  deleteAlbum: (albumId) => api.delete(`/albums/${albumId}`),
  moveScreenshotToAlbum: (screenshotId, albumId) =>
    api.patch(`/albums/screenshots/${screenshotId}/move`, { album_id: albumId }),
}

export const badgeAPI = {
  getAllTypes: () => api.get('/badges/types'),
  getUserBadges: (userId) => api.get(`/badges/user/${userId}`),
  createType: (data) => api.post('/badges/types', data),
  updateType: (badgeTypeId, data) => api.patch(`/badges/types/${badgeTypeId}`, data),
  deleteBadgeType: (badgeTypeId) => api.delete(`/badges/types/${badgeTypeId}`),
  awardBadge: (userId, badgeTypeId) => api.post('/badges/award', { userId, badgeTypeId }),
  revokeBadge: (userId, badgeTypeId) => api.post('/badges/revoke', { userId, badgeTypeId }),
  listRecentAwards: (limit = 50) => api.get('/badges/recent-awards', { params: { limit } }),
  setMyBadgeVisibility: (badgeTypeId, hidden) =>
    api.patch(`/badges/me/${badgeTypeId}/visibility`, { hidden }),
  reorderMyBadges: (order) => api.post('/badges/me/reorder', { order }),
}
